{
  "title": "Dashboard",
  "meta": {
    "sino_last_call": "Sino last call {{age}}",
    "marketplace_sync": "Marketplace sync {{age}}"
  },
  "kpi": {
    "block_title": "Today",
    "got_awb": "Labels received",
    "got_awb_caption": "Shipping labels (AWB) Sino returned, by pick time",
    "stuck": "Stuck (picked, no label)",
    "stuck_caption": "Picked but no shipping label yet",
    "stuck_sub": "{{total}} stuck · {{n}} ready to retry →",
    "last_confirm_pick": "Last confirm pick",
    "last_confirm_pick_caption": "Since Sino last confirmed a pick",
    "needs_attention": "Needs attention",
    "needs_attention_caption": "Orders waiting for a decision",
    "by_reason": "{{oversold}} oversold · {{buyer_cancel_requested}} buyer cancel →"
  },
  "win": {
    "h1": "1h",
    "h24": "24h",
    "d7": "7d"
  },
  "pipeline": {
    "title": "Marketplace health",
    "checked": "Checked {{age}} · refreshes every minute",
    "mp": {
      "shopee": "Shopee",
      "lazada": "Lazada",
      "tiktok": "TikTok"
    },
    "token": "Connection",
    "token_hint": "Marketplace login token",
    "ingest": "Orders pulled in",
    "ingest_hint": "Last pull · orders today",
    "ingest_today": "· {{n}} today",
    "stock_push": "Stock sync to marketplace",
    "stock_push_hint": "How stock changes reach the shop",
    "recon_gaps": "Missing vs Seller Center",
    "recon_gaps_hint": "Orders the shop has that Atlas doesn't",
    "connected": "Connected",
    "expiring": "Expires in {{days}}d",
    "not_connected": "Not connected",
    "live": "Live",
    "paused": "Paused {{time}}",
    "shadow": "Shadow",
    "off": "Off",
    "reconnect": "Reconnect"
  },
  "stuck": {
    "title": "Stuck after confirm pick",
    "title_count": "Stuck after confirm pick ({{n}})",
    "caption": "Picked but no shipping label yet · oldest first",
    "include_sof": "include Seller Own Fleet",
    "sla_hours": "{{h}}h",
    "picked_at": "picked {{time}}",
    "attempts_n": "×{{n}} tried",
    "col_order": "Order",
    "col_status": "Status",
    "col_stuck": "Stuck for",
    "col_sla": "Ship by",
    "col_problem": "Problem",
    "cause": {
      "reconnect": "Marketplace not connected",
      "retry": "Label request failed",
      "pending": "Waiting for first attempt",
      "never_tried": "Label never requested"
    },
    "retry": "Retry AWB",
    "retry_all": "Retry all {{n}}",
    "retrying": "Retrying…",
    "empty": "No stuck orders."
  },
  "notif": {
    "title": "Action required",
    "caption": "P1/P2 alerts with a next step",
    "empty": "Nothing needs your action",
    "action": {
      "reconnect": "Reconnect",
      "open_order": "Open order",
      "open_inventory": "Open inventory",
      "open_inventory_mkp": "Open {{mkp}} inventory",
      "open_diff": "Open diff",
      "open_inbound": "Open inbound"
    }
  },
  "age": {
    "just_now": "just now",
    "minutes": "{{n}}m ago",
    "hours": "{{h}}h {{m}}m ago",
    "days": "{{n}}d ago",
    "none": "—"
  },
  "btn": {
    "export": "Export"
  },
  "error": {
    "block": "Couldn't load this block."
  }
}
